import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'
import backgroundImg from './img/background.png'

const Intro = ({
  coupleData: { coupleFirstName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro346">
      <div className="animated-intro-large-all-breakpoints screen">
        <img
          className="background-mJEZdQ bp2-animate-enter"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-mJEZdQ">
          <div
            className="site-de-casamento-e-Ifj7wC"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-Ifj7wC smart-layers-pointers">
            <div className="pular-introduo-cSB8CC" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-mJEZdQ notranslate">
          <div className="mariana-eduardo-c06wRT bp2-animate-enter1">
            <span className="span0-uqc8Ft">{coupleFirstName.bride} </span>
            <span className="span1-uqc8Ft">+ </span>
            <span className="span2-uqc8Ft">
              {coupleFirstName.groom && coupleFirstName.groom}
            </span>
          </div>
        </div>
      </div>
      <div className="animated-intro-small screen">
        <img
          className="background-4QFuFN bp1-animate-enter"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-4QFuFN">
          <div
            className="site-de-casamento-e-YrZHDo"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-YrZHDo smart-layers-pointers">
            <div className="pular-introduo-8N8PwH" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-4QFuFN notranslate">
          <div className="mariana-eduardo-DINxli bp1-animate-enter1">
            <span className="span0-2y6iHx signatie-regular-normal-gravel-40px">
              {coupleFirstName.bride}{' '}
            </span>
            <span className="span1-2y6iHx">+ </span>
            <span className="span2-2y6iHx signatie-regular-normal-gravel-40px">
              {coupleFirstName.groom && coupleFirstName.groom}
            </span>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
